import { inject, Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { AccountStateStore } from './account-state-store';
import { AccountState } from './account-state.model';

@Injectable({
  providedIn: 'platform',
})
export class AccountStateQuery extends Query<AccountState> {
  public constructor() {
    super(inject(AccountStateStore));
  }
}
